// extracted by mini-css-extract-plugin
export default {"wrapper":"StoryTelling_wrapper__66JwX","timeline":"StoryTelling_timeline__4H1SL","content":"StoryTelling_content__PnuHD"};